import { Contacts } from "../modules"

export const ContactsPage = () => {
  return (
    <Contacts />
  )
}
